import { IChangePropertyPayload } from '@dash/editForm';
import {
  LoadFormInfoRequestAction,
  LoadFormInfoSuccessAction,
  LoadFormInfoErrorAction,
  ChangePropertyAction,
  LoadPaymentSettingsRequestAction,
  LoadPaymentSettingsSuccessAction,
  LoadPaymentSettingsErrorAction,
  UpdatePaymentDetailsRequestAction,
  UpdatePaymentDetailsSuccessAction,
  UpdatePaymentDetailsErrorAction,
} from './actions.d';
import actionsTypes from './actionTypes';
import {
  Attribute,
  IFieldTypes,
  ILoadDataRequestPayload,
  ILoadFormDataSuccessPayload,
  ILoadPaymentSettingsSuccessPayload,
  IUpdatePaymentDetailsPayload,
} from './types.d';

const actions = {
  loadFormInfoRequest: <T1, T2>(payload: ILoadDataRequestPayload<T1, T2>): LoadFormInfoRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_FORM_INFO_REQUEST,
    payload,
  }),

  loadFormInfoSuccess: (payload: ILoadFormDataSuccessPayload): LoadFormInfoSuccessAction => ({
    type: actionsTypes.LOAD_FORM_INFO_SUCCESS,
    payload,
  }),

  loadFormInfoError: (): LoadFormInfoErrorAction => ({
    type: actionsTypes.LOAD_FORM_INFO_ERROR,
  }),

  loadPaymentSettingsRequest: <T1, T2>(
    payload: ILoadDataRequestPayload<T1, T2>,
  ): LoadPaymentSettingsRequestAction<T1, T2> => ({
    type: actionsTypes.LOAD_PAYMENT_SETTINGS_REQUEST,
    payload,
  }),

  loadPaymentSettingsSuccess: (payload: ILoadPaymentSettingsSuccessPayload): LoadPaymentSettingsSuccessAction => ({
    type: actionsTypes.LOAD_PAYMENT_SETTINGS_SUCCESS,
    payload,
  }),

  loadPaymentSettingsError: (): LoadPaymentSettingsErrorAction => ({
    type: actionsTypes.LOAD_PAYMENT_SETTINGS_ERROR,
  }),

  changeProperty: (payload: IChangePropertyPayload<Attribute, IFieldTypes>): ChangePropertyAction => ({
    type: actionsTypes.CHANGE_PROPERTY,
    payload,
  }),

  updatePaymentDetailsRequest: (payload: IUpdatePaymentDetailsPayload): UpdatePaymentDetailsRequestAction => ({
    type: actionsTypes.UPDATE_PAYMENT_DETAILS_REQUEST,
    payload,
  }),

  updatePaymentDetailsSuccess: (): UpdatePaymentDetailsSuccessAction => ({
    type: actionsTypes.UPDATE_PAYMENT_DETAILS_SUCCESS,
  }),

  updatePaymentDetailsError: (): UpdatePaymentDetailsErrorAction => ({
    type: actionsTypes.UPDATE_PAYMENT_DETAILS_ERROR,
  }),
};

export default actions;
